/**
 * 当前语言的千分位与小数点符号（由应用按语言提供，@nexora/i18n 的 numberSymbols(lang)）。
 * 单独成模块：应用根只需要 NumberSymbolsProvider，不必把金额组件与 decimal.js 带进首屏入口（PRD §8.1 首屏体积）。
 */
import { createContext, useContext, type ReactNode } from 'react';
import { DEFAULT_NUMBER_SYMBOLS, type NumberSymbols } from '@nexora/shared';

const NumberSymbolsContext = createContext<NumberSymbols>(DEFAULT_NUMBER_SYMBOLS);

export function NumberSymbolsProvider({ symbols, children }: { symbols: NumberSymbols; children: ReactNode }) {
  return <NumberSymbolsContext.Provider value={symbols}>{children}</NumberSymbolsContext.Provider>;
}

export function useNumberSymbols(): NumberSymbols {
  return useContext(NumberSymbolsContext);
}
